import React, { useState, useEffect } from 'react';
import './Clock.css';
import clockSun from '../../assets/images/clock-sun.png';

const Clock: React.FC = () => {
  const [time, setTime] = useState<string>('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      setTime(`${hours}:${minutes}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="clock">
      <span>{time}</span>
      <img src={clockSun} alt="Clock Sun" className="clock-sun" />
    </div>
  );
};

export default Clock; 